import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderBottomColor: '#bff0fd',
        backgroundColor: '#bff0fd',
        borderBottomWidth: 1,
        alignItems: 'center',
        textAlign: 'center',
        fontStyle: 'bold',
        flexGrow: 1,
    },
    description: {
        width: '20%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        flexDirection: 'column'
    },
    qty: {
        width: '30%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    rate: {
        width: '30%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    amount: {
        width: '20%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        flexDirection: 'column'
    },
  });

  const ShareCertificateTableHeader = () => (
    <View style={styles.container}>
        <Text style={styles.description}>Share Class</Text>
        <Text style={styles.qty}>Total No. of Shares</Text>
        <Text style={styles.rate}>Amount Paid Per Share $</Text>
        <Text style={styles.amount}>Amount Unpaid Per Share $</Text>
    </View>
  );
  
  export default ShareCertificateTableHeader